import { HttpResult } from 'widgets-for-react'
import { ParsedPhoneNumber, parsePhoneNumber } from '../../../../../utils/phoneNumber'

type PhoneNumbersApiResponse = {
  PhoneNumber: string
  SharepointId: number
  Description: string
}[]

export const peopleBlockApi = async (ids: number[]): Promise<HttpResult<Map<number, ParsedPhoneNumber>>> => {
  const results = new Map<number, ParsedPhoneNumber>()

  const data: PhoneNumbersApiResponse = await (
    await fetch(`/api/v1/phoneNumbers?${ids.map((id) => `ids=${id}`).join('&')}`)
  ).json()

  data.map((item) => results.set(item.SharepointId, parsePhoneNumber(item.PhoneNumber)))

  return {
    status: 200,
    kind: 'result',
    value: results,
  }
}
